/*
THIS INFRAGISTICS ULTIMATE SOFTWARE LICENSE  AGREEMENT ("AGREEMENT") LOCATED HERE:
https://www.infragistics.com/legal/license/igultimate-la
https://www.infragistics.com/legal/license/igultimate-eula
GOVERNS THE LICENSING, INSTALLATION AND USE OF INFRAGISTICS SOFTWARE. BY DOWNLOADING AND/OR INSTALLING AND USING INFRAGISTICS SOFTWARE:  you are indicating that you have read and understand this Agreement, and agree to be legally bound by it on behalf of the yourself and your company.
*/
import * as tslib_1 from "tslib";
import { Base, markType } from "igniteui-react-core";
import { IViewportManager_$type } from "./IViewportManager";
/**
 * @hidden
 */
var DataGridViewportManager = /** @class */ /*@__PURE__*/ (function (_super) {
    tslib_1.__extends(DataGridViewportManager, _super);
    function DataGridViewportManager(a) {
        var _this = _super.call(this) || this;
        _this.a = null;
        _this.a = a;
        return _this;
    }
    DataGridViewportManager.prototype.moveViewportTo = function (x_, y_) {
        var grid_ = this.a;
        if (grid_._scrollTo) {
            grid_._scrollTo(x_, y_);
        }
        else {
            grid_.scrollTo(x_, y_);
        }
        ;
    };
    DataGridViewportManager.$t = markType(DataGridViewportManager, 'DataGridViewportManager', Base.$, [IViewportManager_$type]);
    return DataGridViewportManager;
}(Base));
export { DataGridViewportManager };
//# sourceMappingURL=DataGridViewportManager.js.map
